module.exports = __webpack_public_path__ + "img/ARM_Logo_Color.5802799b.svg";